import { render } from "./Main.vue?vue&type=template&id=53850680&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=53850680&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-53850680"

export default script